import BigNumber from 'bignumber.js'
import { DEFAULT_TOKEN_DECIMAL } from 'config'

export const depositVault = async (vaultContract, amount, decimals = DEFAULT_TOKEN_DECIMAL) => {
  const value = new BigNumber(amount).times(decimals).toString()
  const tx = await vaultContract.deposit(value)
  const receipt = await tx.wait()
  return receipt.status
}

export const withdrawVault = async (vaultContract, amount, decimals = DEFAULT_TOKEN_DECIMAL) => {
  const value = new BigNumber(amount).times(decimals).toString()
  const tx = await vaultContract.withdraw(value)
  const receipt = await tx.wait()
  return receipt.status
}

export const compoundVault = async (contract) => {
  const tx = await contract.harvest()
  const receipt = await tx.wait()
  return receipt.status
}

export const registerPricePerfullShareData = async (token, walletAddress, vaultsAddress, pricePerFullShare) => {
  const response = await fetch(`${process.env.REACT_APP_API}/earns/regiserPricePerfullShare`, {
    method: 'POST',
    body: JSON.stringify({
      walletAddress,
      vaultsAddress,
      pricePerFullShare,
    }),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
  const result = await response.json()
  return result
}
